import { cn } from "@repo/shared/utils";
import { Autocomplete, type AutocompleteOption } from "./Autocomplete";
import { Input, type InputProps } from "./Input";

export interface AutocompleteInputProps
  extends Omit<InputProps, "value" | "onChange"> {
  autocompleteOptions: (string | AutocompleteOption)[];
  filterOptions?: boolean;
  value?: string;
  onChange?: (value: string) => void;
}

export const AutocompleteInput = ({
  autocompleteOptions,
  filterOptions = true,
  value,
  onChange,
  ...props
}: AutocompleteInputProps) => {
  return (
    <Input
      value={value}
      autoComplete="off"
      onChange={(evt) => {
        onChange?.(evt.target.value);
      }}
      {...props}
      wrapper={({ children }) => (
        <Autocomplete
          autocompleteOptions={autocompleteOptions}
          filterText={filterOptions ? value : ""}
          onSelect={(option) => onChange?.(option)}
          className={cn("w-full", props.inputStyle)}
        >
          {children}
        </Autocomplete>
      )}
    />
  );
};
